import { useTranslation } from "@localization/useTranslation.ts";
import DeleteBlockedDialog from "@common/components/deleteBlockedDialog/DeleteBlockedDialog.tsx";
import { DeletionBlockerGroup } from "@common/components/deleteBlockedDialog/DeleteBlockedDialog.types.ts";
import { legalEntityBlockerNoAccessTranslationKeys, legalEntityBlockerTranslationKeys } from "./DeleteLegalEntityBlockedDialog.hooks.ts";

export interface IDeleteLegalEntityBlockedDialogProps {
    legalEntityName: string;
    blockers: Array<DeletionBlockerGroup>;
    onDialogClose: () => void;
}

function DeleteLegalEntityBlockedDialog(props: IDeleteLegalEntityBlockedDialogProps) {
    const { translateString } = useTranslation();

    return (
        <DeleteBlockedDialog
            header={translateString("legalEntityCannotBeDeletedHeader")}
            description={translateString("legalEntityCannotBeDeletedDescription", { name: props.legalEntityName })}
            advice={translateString("legalEntityCannotBeDeletedDeactivateInstead")}
            blockers={props.blockers}
            blockerTranslationKeys={legalEntityBlockerTranslationKeys}
            blockerNoAccessTranslationKeys={legalEntityBlockerNoAccessTranslationKeys}
            onDialogClose={props.onDialogClose}
        />
    );
}

export default DeleteLegalEntityBlockedDialog;
